"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chat$ = void 0;
var effector_1 = require("effector");
exports.Chat$ = effector_1.createStore({ session: null });
//# sourceMappingURL=index.js.map